import axios from 'axios'

// Private Component
import config from '../config'

const BASE_URL = config.BASE_URL
const apiX = axios.create({
	baseURL: BASE_URL
})

/* Firebase Storage for image  */
export const getImageByEvent = async (_eid) => {
	return apiX
		.get(BASE_URL + `api/image/event/list/` + _eid)
}

/* Firebase Cover for event  */
export const getCoverByEvent = async (_eid) => {
	return apiX
		.get(BASE_URL + `api/image/event/cover/` + _eid)
}

/**
 * Migration from OVH server to Firebase Storage
 * @param _entityType
 * @param _entityId
 * @param _oldUrl
 * @returns {Promise<void>}
 */
export const legacyMigrationByServerUrlToFirebase =  (_entityType, _entityId, _oldUrl) => {
	return  apiX.post('/api/image/migrate', {
		entityType: _entityType,
		entityId: _entityId,
		imageUrl: _oldUrl,
	})
}




